import { jsx } from "react/jsx-runtime";
import { Tooltip } from "@mui/material";
import { inheritDataTestId } from "../../utils/dataTestId.js";
import { useState, useRef, useEffect } from "react";
const popperProps = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, -8]
      }
    },
    {
      name: "flip",
      options: {
        fallbackPlacements: ["left", "top", "bottom"]
      }
    }
  ]
}, ErrorTooltip = ({ children, ...props }) => {
  const [open, setOpen] = useState(!0), tmtRef = useRef(void 0);
  return useEffect(() => {
    tmtRef.current = setTimeout(() => {
      setOpen(void 0);
    }, 1e4);
  }, []), /* @__PURE__ */ jsx(
    Tooltip,
    {
      title: props.title,
      open,
      onOpen: () => {
        clearTimeout(tmtRef.current), setOpen(void 0);
      },
      leaveDelay: 1e3,
      enterDelay: 400,
      onClose: () => {
        setOpen(void 0);
      },
      "data-test-id": inheritDataTestId(props, "error-tooltip"),
      placement: "right",
      slotProps: {
        popper: popperProps
      },
      componentsProps: {
        tooltip: {
          sx: styles.tooltip,
          onClick: () => {
            setOpen(!1), setTimeout(() => {
              setOpen(void 0);
            });
          }
        },
        arrow: {
          sx: styles.arrow
        }
      },
      arrow: !0,
      children
    },
    open == null ? 0 : open ? 2 : 1
  );
}, styles = {
  tooltip: {
    backgroundColor: (t) => t.palette.hint.critical.bg,
    maxWidth: 180,
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 500,
    padding: "6px 9px",
    '[data-popper-placement="bottom"] &, [data-popper-placement="top"] &': {
      maxWidth: 300
    }
  },
  arrow: { color: (t) => t.palette.hint.critical.bg }
};
export {
  ErrorTooltip
};
//# sourceMappingURL=ErrorTooltip.js.map
